import React, { useState } from "react";
import Layout from "../../Layout/Layout";
import MainContent from "./MainContent/MainContent";

export default function Settings() {
  const [showGroupSection, setShowGroupSection] = useState(false);
  const [isNewChannel, setIsNewChannel] = useState(false);

  return (
    <Layout
      showGroupSection={showGroupSection}
      setShowGroupSection={setShowGroupSection}
      isNewChannel={isNewChannel}
      setIsNewChannel={setIsNewChannel}
    >
      <MainContent>
        Hello good morning
      </MainContent>
    </Layout>
  );
}
